import { GetOrderRequest, SearchOrderRequest } from '@trukt/tms-api';
import { createKey } from '../createKey';
import {
  OrderCommodityServiceKeys,
  OrderFinancesServiceKeys,
  OrderJobsServiceKeys,
  OrderPartyServiceKeys,
} from './serviceKeys';
import { OrderClassificationServiceKeys } from '../OrderClassificationServiceKeys';

const keyHandler = createKey('order');

export const OrderServiceKeys = {
  key: keyHandler.key,
  commodities: OrderCommodityServiceKeys,
  classification: OrderClassificationServiceKeys,
  finance: OrderFinancesServiceKeys,
  getById: keyHandler.createMethod<GetOrderRequest>(),
  job: OrderJobsServiceKeys,
  party: OrderPartyServiceKeys,
  search: keyHandler.createMethod<SearchOrderRequest>(),
};
